import router from '@/router'
import AccessControl from '@/services/access-control.service'
import {Notification, Loading} from 'element-ui'
import AuthService from '@/services/auth.service'
/**
 * 'Router.config'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

let loadingInstance = null

router.beforeEach((to, from, next) => {
  loadingInstance = Loading.service()
  AccessControl.check(to)
    .then(() => {
      next()
    })
    .catch((error) => {
      console.error(error)
      Notification.error({
        title: 'Sin acceso a ' + to.name,
        message: 'Debe de autenticarse para acceder a esta ruta'
      })
      AuthService.redirectURL = Object.assign({}, to)
      next(AuthService.__errorRoute__)
    })
})

router.beforeResolve((to, from, next) => {
  next()
})

router.afterEach((to, from) => {
  loadingInstance.close()
})

router.onError((error) => {
  console.error(error)
  loadingInstance.close()
})



// WEBPACK FOOTER //
// ./src/config/router.config.js